<div class="sorteos__labelInput">
    <label class="sorteos__label" for="fecha">Fecha</label>
    <mat-form-field class="sorteos__formCalendar" appearance="none" [showButtonBar]="true" [readonlyInput]="true">
        <input matInput [matDatepicker]="picker" id="fecha" placeholder=" " (dateChange)="fechaSeleccionada($event)" class="sorteos__inputFecha" readonly="true">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
</div>